<template>
    <div align="center" style="height: auto">
        <div class="commonSearch bottom" ref="commonSearchRef" :style="defaultHeight">
            <el-card class="box-card1">
                <div>
                    <div>
                        <span style="font-size: 22px;margin-right: 10px">{{form.faulttypeName}}</span>
                        <el-button class="state" v-if="form.status==1" style="border-color: #F56C6C;color: #F56C6C;">新受理</el-button>
                        <el-button class="state" v-if="form.status==2 || form.status==3" style="border-color: #E6A23C;color: #E6A23C;">处理中</el-button>
                        <el-button class="state" v-if="form.status==4 || form.status==5" style="border-color: #67C23A;color: #67C23A;">已完成</el-button>
                    </div>
                    <div style="font-size: 16px;">报修时间:&nbsp;&nbsp;{{form.createdate}}</div>
                    <div style="font-size: 16px;">报修单号:&nbsp;&nbsp;{{form.repaircode}}</div>
                </div>
            </el-card>

            <el-card class="box-card2">
                <div style="height: 30vh;margin-left: 70px;margin-top: 40px">
                    <el-steps direction="vertical" :active="this.active">
                        <el-step title="待维修"></el-step>
                        <el-step title="维修中"></el-step>
                        <el-step title="待评价"></el-step>
                        <el-step title="已评价"></el-step>
                    </el-steps>
                </div>
                <el-button style="color: #508BD5;border-color: #508BD5;margin-right: 35px;margin-top: 16vh" @click="rollBack">返回</el-button>
            </el-card>
        </div>
    </div>
</template>

<script>
import TabResize from "@/utils/TabResizeEx.js";
import RepairsApi from "@/api/repairs.js";

export default {
    mixins: [TabResize],
    components: {},

    data () {
        return {
            id: "",
            form: {
                createdate: "",
                faultdescription: "",
                repaircode: "",
                status: '',
                userid: "",
            },
            active: "",
            defaultHeight: {
                height: ""
            }
        };
    },

    mounted: function () {
        if (this.$route.query.id != null) {
            let id = this.$route.query.id;
            this.findOrderById(id);
        } else {

        }
    },

    methods: {
        findOrderById (id) {
            this.active = "";
            RepairsApi.getClass()
                .findOrderById(id).then(resp => {
                    if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                        let data = resp.data.data;
                        if (data.status == "100401") {
                            this.active = 1
                        } else if (data.status == "100402") {
                            this.active = 2
                        } else if (data.status == "100404") {
                            this.active = 3
                        } else if (data.status == "100405") {
                            this.active = 4
                        }
                        this.form = data;
                    } else {
                        this.$message.error(resp.data.msg);
                        return false;
                    }
                }).catch(err => {
                    this.$message.error(err);
                    return false;
                });
        },

        //返回上一页
        rollBack () {
            this.$router.push({
                name: "ViewDetails",
                query: { id: this.$route.query.id }
            });
        },
        getHeight () {
            this.defaultHeight.height = window.innerHeight - 90 + "px";
        }
    },
    created () {
        //页面创建时执行一次getHeight进行赋值，顺道绑定resize事件
        window.addEventListener("resize", this.getHeight);
        this.getHeight();
    }
};
</script>

<style lang="stylus" scoped>
.bottom {
    width: 90%;
    height: 824px;
    overflow: auto;
}

/deep/.el-button--small {
    margin-left: 15px;
}

.state {
    font-size: 12px;
    height: 30px;
    width: 65px;
}

.box-card1 {
    width: 500px;
    height: 110px;
    margin-top: 20px;
    margin-bottom: 15px;
    text-align: left;
}

.box-card2 {
    width: 500px;
    height: 68vh;
    overflow: auto;
}
</style>